import { createReducer, createActions } from 'reduxsauce'
import { CommonReducer, Reducer } from '../Utils/reduxHelpers'
import { Action } from 'redux'
import { ReducerTypes } from './utils'
import {ReminderSettings} from '../interfaces'

type ActionTypes = {
    POST_REMINDER_SETTINGS: string
    POST_REMINDER_SETTINGS_FAILURE: string
    POST_REMINDER_SETTINGS_SUCCESS: string
}

const actions = {
    postReminderSettings: ['settings', 'callbacks'],
    postReminderSettingsFailure: null,
    postReminderSettingsSuccess: ['settings'],
}

type AnyCreators = {
    [key in keyof typeof actions]: (...params: any[]) => Action<any>
}

// Override AnyCreators with strong types
interface Creators extends AnyCreators {
    postReminderSettings: (settings: ReminderSettings) => Action<any>
}

const { Types, Creators } = createActions<ActionTypes, Creators>(actions)

export const ReminderTypes = Types
export default Creators

export interface ReminderState {
    fetching: {
        reminderSettings: boolean
    }
    result: any
}

export const INITIAL_STATE: ReminderState = {
    fetching: {
        reminderSettings: false,
    },
    result: null,
}

type CommonFetchingType = keyof ReminderState['fetching']

const commonFetching = (type: CommonFetchingType): CommonReducer<any> => (
    state: any,
) => ({
    ...state,
    fetching: {
        ...state.fetching,
        [type]: true,
    },
})
const commonFailure = (type: CommonFetchingType): CommonReducer<any> => (
    state: any,
) => ({
    ...state,
    fetching: {
        ...state.fetching,
        [type]: false,
    },
})

/* -------------- Reminder management reducers -------------- */
const REMINDER_SETTINGS = 'reminderSettings'
export const postReservation: CommonReducer<ReminderState> = commonFetching(
    REMINDER_SETTINGS,
)
export const postReservationSuccess: Reducer<ReminderState> = (
    state,
    { result },
) => ({
    ...state,
    result,
    fetching: { ...state.fetching, [REMINDER_SETTINGS]: false },
})
export const postReservationFailure: CommonReducer<ReminderState> = commonFailure(
    REMINDER_SETTINGS,
)

type ReminderReducerTypes = ReducerTypes<ReminderState, ActionTypes>

export const reducerTypes: ReminderReducerTypes = {

    [Types.POST_REMINDER_SETTINGS]: postReservation,
    [Types.POST_REMINDER_SETTINGS_SUCCESS]: postReservationSuccess,
    [Types.POST_REMINDER_SETTINGS_FAILURE]: postReservationFailure,
}

export const reducer = createReducer<
    ReminderState,
    Action<ReminderReducerTypes>
>(INITIAL_STATE, reducerTypes)
